/**
 * @file GetAdditionalTitleTarget
 */

'use strict';

/**
 * @classname GetAdditionalTitleTarget
 * @classdesc 銃登録対象者取得
 */
export default class GetAdditionalTitleTarget {
	/**
	 * @constructor
	 * @param {jQuery} $e - .page-additional-title-apply [name=apply_type]
	 */
	constructor($e, controller) {
		console.log(`GetAdditionalTitleTarget.constructor`);
		this._$e = $e;
		this._controller = controller;
		this._post = false;
		this._$e.on('change', () => this.onChange());
		this._controller.on('getAdditionalTitleTargetComplete', () => this.onGetAdditionalTitleTargetComplete());
		if($('#apply_type_1').prop('checked')){
			// 最初から今年度がチェックされている場合は表示する
			this.onChange();
		} else if (!$('#apply_type_2')[0]) {
			// 最初から今年度がチェックされていないが次年度がない場合は今年度を選択する
			$('#apply_type_1').click();
		}
	}


	/**
	 * 'change' のコールバック
	 *
	 * @memberof GetAdditionalTitleTarget
	 * @return {undefined}
	 */
	onChange() {
		console.log(`GetAdditionalTitleTarget.onChange`);
		this._post = true;
		this._controller.getAdditionalTitleTarget();
		$('#additional-title-text').hide();
		$('#additional-title-wrap').show();
	}


	/**
	 * 所属リスト取得完了コールバック
	 *
	 * @memberof GetAdditionalTitleTarget
	 * @return {undefined}
	 */
	onGetAdditionalTitleTargetComplete() {
		if (!this._post) return;
		console.log(`GetAdditionalTitleTarget.onGetAdditionalTitleTargetComplete`);
		const items = this._controller._additionalTitleMemberData;
		console.log(items);
		const options = this.createOptions(items);
		const $select = $('[name=member_id]');
		$select.html(options);
		this._controller.resetSelect2();
		this._post = false;
	}


	/**
	 * option生成
	 *
	 * @memberof GetAdditionalTitleTarget
	 * @param {object} items - ajax返却データ
	 * @return {string} options - select option
	 */
	createOptions(items) {
		console.log(`GetAdditionalTitleTarget.createOptions`);
		let options = '<option value=""></option>';
		items.forEach(item => {
			console.log(`enabled: ${item.text}`)
			options += item.enabled ? `<option value='${item.id}'>${item.text}</option>` : `<option value='${item.id}' disabled>${item.text}</option>`;
		});
		return options
	}
}
